import React from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import LandingPage from './LandingPage';
import GamePage from './GamePage';

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/play" element={<GamePage />} />
        {/* Old bookmarks lead to local setup without carrying room parameters. */}
        <Route path="/lobby" element={<Navigate to="/play" replace />} />
        <Route path="/game" element={<Navigate to="/play" replace />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
